import { useState, useEffect } from "react";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const btnExitStyles = {
  zIndex: 10,
  position: "absolute",
  top: "20px",
  right: "23px",
  color: "#004990",
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)"
}

export default function RegisterModal({children, isOpen, handleClose, handleModal}){
  const [open, setOpen] = useState(false);

  //controlar el estado de la alerta desde el componente padre
  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleCloseModal = () => {
    handleModal(false);
    setOpen(false);
  }

  return(
    <Dialog sx={{display: {xs: "none", sm: "none", md: "block"}}} open={open} fullWidth maxWidth="md" scroll="body">
      <IconButton sx={btnExitStyles} onClick={handleCloseModal}>
        <CloseIcon/>
      </IconButton>
      {children}
    </Dialog>
  );  
}